<template>
  <!-- Signature area: white, dashed border, "Firma aquí" until something is
       drawn and a visible button to clear it. Same methods as VueSignaturePad
       (saveSignature, clearSignature, resizeCanvas), so the views keep their
       calls. -->
  <div class="signature-box" :class="{error: error}">
    <div class="signature-box-head">
      <span class="signature-box-label">{{ label }}</span>
      <button type="button" class="signature-box-clear" v-on:click="clearSignature()" :disabled="empty">
        <font-awesome-icon :icon="['fas', 'trash']" /> {{ app.strings.practice.menu.card.clear }}
      </button>
    </div>
    <div class="signature-box-pad">
      <VueSignaturePad :height="height" ref="pad" :options="{
        backgroundColor: 'rgb(255, 255, 255)',
        onBegin: begin
      }" />
      <div class="signature-box-hint" v-if="empty">{{ app.strings.practice.menu.card.sign_here }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'signature-box-component',
  props: {
    app: Object,
    label: String,
    height: {
      type: String,
      default: '150px'
    },
    error: Boolean
  },
  data () {
    return {
      empty: true
    }
  },
  mounted () {
    // The pad may be laid out after mount (modals, columns): size it then.
    this.$nextTick(() => this.resizeCanvas())
  },
  methods: {
    begin () {
      this.empty = false
    },
    saveSignature (type) {
      return this.$refs.pad.saveSignature(type)
    },
    clearSignature () {
      this.$refs.pad.clearSignature()
      this.empty = true
    },
    resizeCanvas () {
      if (this.$refs.pad) {
        this.$refs.pad.resizeCanvas()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.signature-box {
  margin-top: 12px;
  text-align: left;
}

.signature-box-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 6px;
}

.signature-box-label {
  color: #64748b;
  font-family: 'Lexend', sans-serif;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.signature-box-clear {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 5px 10px;
  border: 1px solid #e8edf3;
  border-radius: 10px;
  background-color: #FFFFFF;
  color: #b91c1c;
  font-family: 'Lexend', sans-serif;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
}

.signature-box-clear:disabled {
  color: #cbd5e1;
  cursor: default;
}

.signature-box-pad {
  position: relative;
  overflow: hidden;
  border: 2px dashed #b9c7d8;
  border-radius: 14px;
  background-color: #FFFFFF;
}

.signature-box.error .signature-box-pad {
  border-color: #dc2626;
}

.signature-box-hint {
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  transform: translateY(-50%);
  color: #94a3b8;
  font-family: 'Lexend', sans-serif;
  font-size: 16px;
  text-align: center;
  pointer-events: none;
}
</style>
